import { graphql } from 'relay-runtime';

export const DataValidationCustomRulesListQuery = graphql`
  query dataValidationCustomRulesListQuery($owner: String) {
    validationCustomRulesList(owner: $owner) {
      resourceName
      displayName
    }
  }
`.default;
